import actionConstants from '../constants/';
import { LOGIN_CONSTANTS } from '../../lib/constants';
import { setIsLiveMerchant } from '../../lib/localStorage';
import {
  getDefaultSelectedProduct,
  getSelectedProductFromPath,
} from 'lib/helper';
import { max } from 'date-fns';

const generateUserData = (
  body: { [key: string]: any } = {},
  productPath = ''
) => {
  setIsLiveMerchant(
    `${'isLiveMerchant' in body ? body?.isLiveMerchant : true}`
  );

  let merchantVersion = body?.merchantVersion;
  let checkoutVersion: string | null = null; 
  if (merchantVersion === "v31" || merchantVersion === "V31") {
    merchantVersion = "V3";
    checkoutVersion = "V31";
  }

  // Some fields (e.g. MerchantName) are nested inside stringified body.data.
  // Safely parse once and reuse.
  let parsedData: any = {};
  try {
    parsedData = body?.data ? JSON.parse(body.data) : {};
  } catch (e) {
    parsedData = {};
  }
  
  return {
    token: body.Token,
    isUserAuthenticated: true,
    tokenExpiry: body.tokenExpiry,
    PasswordExpireDays: body.PasswordExpireDays,
    ThresholdRemainingDaysForPwdExpiryAlert:
      body.ThresholdRemainingDaysForPwdExpiryAlert,
    tokenExpiryInSec: body.tokenExpiryInSec,
    MerchantId: body?.isAdmin ? 0 : body.MerchantId,
    unifiedId: body?.unifiedMID,
    selectedProduct: productPath
      ? getSelectedProductFromPath(productPath, body?.mappedProducts)
      : getDefaultSelectedProduct(body?.mappedProducts),
    failedLoginTime: body.FAILED_LOGIN_TIME,
    lastLoggedIn: body.LAST_LOGGED_IN,
    UserFullName: body.UserFullName,
    UserEmail: body.emailId,
    merchantPan: body?.pan,
    entityType: body?.entityType || null,
    isWaitingForAPIResponse: false,
    HardLogOutTime: body.HardLogOutTime,
    IdleTimeOutTime: body.IdleTimeOutTime,
    isAdmin: body?.isAdmin,
    userId: body?.userId,
    showTrmPortalLink: body?.isTrmEnabled || false,
    merchantName: JSON.parse(body?.data)?.MerchantName,
    merchantUDFEnabled: body?.isUDFEnabled || false,
    merchantPayoutEnabled: body?.isPayoutEnabled ?? false,
    merchantTPVEnabled: body?.isTPVEnabled ?? false,
    merchantSubscriptionEnabled: body?.mappedProducts?.filter(
      (product) => product?.id === 4 && product?.status === 2
    )?.length > 0
      ? true
      : false,
    MerchantList: body?.MerchantList,
    mappedProducts: body?.mappedProducts ?? [],
    leadId: body?.leadId || null,
    virtualStoreId: body?.virtualStoreId,
    isLiveMerchant: 'isLiveMerchant' in body ? body?.isLiveMerchant : true,
    onboardingSource: body?.onboardingSource || null,
    invalidPath: body?.invalidPath || false,
    showGuidedTour: body?.showGuidedTour || false,
    edgeMerchantPaymentLinkEnabled: body?.isEdgePaymentLinkEnabled || false,
    isPartnerMerchant: body?.isPartnerMerchant,
    subMerchants: body?.subMerchants,
    partnerEdgeMerchantId: body?.partnerEdgeMerchantId,
    isParentMerchant: body?.isParentMerchant,
    partnerId: body?.isPartnerMerchant
    ? body?.partnerMerchantId || body?.MerchantId 
    : body?.isParentMerchant 
        ? body?.MerchantId || 0 
        : 0,
    merchantVersion: body?.merchantVersion,
    isSelfServe: body?.isSelfServe,
    waitTime: body?.waitTime,
    isAdapter: body?.isAdapter,
    isDCC: body?.isDCC,
    isMCC: body?.isMCC,
    isPACB: body?.isPACB,
    isMerchantOnboardedOnLive: body?.is_merchant_onboarded_on_live,
    maxPaymentAllowedLimitInPaise: body?.maxPaymentAllowedLimitInPaise || 0,
    isAggregator: body?.isAggregator,
    isRefundViaPayout: body?.isRefundViaPayout,
    isTransactingMerchant: body?.isTransactingMerchant ?? true,
    isPaCbEnabled: body?.isPaCbEnabled ?? false,
    isFirstLogin: body?.isFirstLogin ?? false,
    commodityType: body?.commodityType ?? '',
    allowedSettlementCurrencies:
      body?.allowedSettlementCurrencies ??
      parsedData?.allowedSettlementCurrencies ??
      parsedData?.AllowedSettlementCurrencies ??
      [],
  };
};
// const generateSelfServeUserData = (
//   body: { [key: string]: any } = {},
//   productPath = ''
// ) => {
//   setIsLiveMerchant(
//     `${'isLiveMerchant' in body ? body?.isLiveMerchant : true}`
//   );

//   return {
//     token: body.token,
//     isUserAuthenticated: true,
//     tokenExpiry: body.token_expiry,
//     PasswordExpireDays: body.password_expire_days,
//     ThresholdRemainingDaysForPwdExpiryAlert:
//       body.ThresholdRemainingDaysForPwdExpiryAlert,
//     tokenExpiryInSec: body.token_expiry_in_sec,
//     MerchantId: body?.isAdmin ? 0 : body.merchant_id,
//     unifiedId: body?.unified_mid,
//     selectedProduct: productPath
//       ? getSelectedProductFromPath(productPath, body?.mapped_products)
//       : getDefaultSelectedProduct(body?.mapped_products),
//     failedLoginTime: body.failed_login_time,
//     lastLoggedIn: body.last_logged_in,
//     UserFullName: body.user_full_name,
//     UserEmail: body.email_id,
//     merchantPan: body?.pan,
//     entityType: body?.entity_type || null,
//     isWaitingForAPIResponse: false,
//     HardLogOutTime: body.HardLogOutTime,
//     IdleTimeOutTime: body.IdleTimeOutTime,
//     isAdmin: body?.admin,
//     userId: body?.user_id,
//     showTrmPortalLink: body?.trm_enabled || false,
//     merchantName: JSON.parse(body?.data)?.merchant_name, // to be done
//     merchantUDFEnabled: body?.udf_enabled || false,
//     merchantPayoutEnabled: body?.payout_enabled ?? false,
//     merchantTPVEnabled: body?.tpv_enabled ?? false,
//     merchantSubscriptionEnabled: body?.subscription_enabled ?? false,
//     MerchantList: body?.merchant_list,
//     mappedProducts: body?.mapped_products ?? [],
//     leadId: body?.lead_id || null,
//     virtualStoreId: body?.virtual_store_id,
//     isLiveMerchant: 'isLiveMerchant' in body ? body?.live_merchant : true,
//     onboardingSource: body?.onboardingSource || null,
//     invalidPath: body?.invalid_path || false,
//     showGuidedTour: body?.show_guided_tour || false,
//     edgeMerchantPaymentLinkEnabled: body?.edge_payment_link_enabled || false,
//     merchantVersion : body?.merchant_version
//   };
// };

const generatePermissionState = (body: { [key: string]: any } = {}) => {
  // Mapping user permissions to a object
  let userPermissionData;
  if (body?.data) {
    userPermissionData =
      JSON.parse(body.data)?.RolePermissionModel?.rolePermissionsParamsData ??
      [];
  }
  const userPermissionObject = {};
  userPermissionData.map((p) => {
    userPermissionObject[p.permissionName] = p.permissionName;
  });

  return {
    ...userPermissionObject,
  };
};

const generateRoleState = (body: { [key: string]: any } = {}) => {
  // Mapping user permissions to a object
  let rolePermissionData;
  if (body?.data) {
    rolePermissionData = JSON.parse(body.data)?.RolePermissionModel ?? {};
  }
  return {
    ...rolePermissionData,
  };
};

const loginState = {
  isLoading: false,
  isSuccess: false,
  isTokenSuccess: false,
  isTokenFailure: false,
  isSilentRefreshLoading: false,
  isFailure: false,
  opCode: 0,
  token: '',
  isUserAuthenticated: false,
  isTokenRefreshed: false,
  tokenExpiry: 0,
  tokenExpiryInSec: 0,
  message: '',
  PasswordExpireDays: 0,
  ThresholdRemainingDaysForPwdExpiryAlert: 0,
  MerchantId: 0,
  mappedProducts: [],
  isWaitingForAPIResponse: true,
  HardLogOutTime: 0,
  IdleTimeOutTime: 0,
  isAdmin: false,
  userId: 0,
  merchantName: '',
  merchantTRMEnabled: false,
  showPasswordExpiryNotification: false,
  showTrmPortalLink: false,
  showOtpScreen: false,
  loginTimeLeft: 0,
  pushClevertapLoginContinueEvent: false,
  UserEmail: '',
  merchantUDFEnabled: false,
  merchantEmailId: '',
  merchantPayoutEnabled: false,
  payoutBankId: '',
  isDCC:false,
  isMCC:false,
  isPACB: false,
  merchantTPVEnabled: false,
  merchantSubscriptionEnabled: false,
  unifiedId: '',
  selectedProduct: {},
  invalidPath: false,
  showGuidedTour: false,
  edgeMerchantPaymentLinkEnabled: false,
  merchantVersion: '',
  isPartnerMerchant: false,
  partnerId: 0,
  subMerchants: [],
  selectedMerchant: "",
  partnerEdgeMerchantId: 0,
  isAdapter: false,
  citi:false,
  maxPaymentAllowedLimitInPaise: 0,
  isAggregator: false,
  isRefundViaPayout: false,
  isLiveMerchant: false,
  checkoutVersion: null,
  isMerchantOnboardedOnLive: false,
  isSelfServe: false,
  otpToken: '',
  isTransactingMerchant: true,
  isDisputesEnabled: null,
  isPaCbEnabled: false,
  isFirstLogin: false,
  commodityType: '',
  allowedSettlementCurrencies: [],
};

const permissionState = {};

const roleState = {};

const logOutState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  isUserLoggedOut: false,
};

const resendEmailState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  error: {},
};

const newUserState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  error: {},
};

const forgetPasswordState = {
  otpToken: '',
  otpExpiryInSeconds: 0,
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  message: '',
};

const validateOtpState = {
  isValid: false,
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  message: '',
  showResendButton: false,
  MerchantList: [],
};

const validateLoginOtpState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  otpExpired: false,
};

const changePasswordState = {
  isPasswordChanged: false,
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  message: '',
};

const saveNewPasswordState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  isPasswordChanged: false,
};

const newSignUpState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
  isSignupCompleted: false,
};

const updateTRMStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  opCode: 0,
};

const clientSecretKeyState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: '',
  message: '',
};

const captchaVerifyState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: '',
  response_code: 0,
  message: '',
};

const userEnvState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  error: {},
};

const trmRedirectUrlState = {
  isSuccess: false,
  isFailure: false,
  trmRedirectUrl: '',
  responseCode: '',
  responseMessage: '',
};

const validateInvitationState = {
  isSuccess: false,
  isFailure: false,
  responseCode: '',
  responseMessage: '',
};

const timerState = {
  isTimerComplete: false,
};

const loginOTPState = {
  isSuccess: false,
  isFailure: false,
  otpToken: '',
  responseCode: '',
  responseMessage: '',
};

const productRefreshTokenState = {
  isSuccess: false,
  isFailure: false,
  isLoading: false,
};

const initialState = {
  loginState: { ...loginState },
  logOutState: { ...logOutState },
  forgetPasswordState: { ...forgetPasswordState },
  validateOtpState: { ...validateOtpState },
  saveNewPasswordState: { ...saveNewPasswordState },
  changePasswordState: { ...changePasswordState },
  newSignUpState: { ...newSignUpState },
  permissionState: { ...permissionState },
  roleState: { ...roleState },
  updateTRMStatusState: { ...updateTRMStatusState },
  clientSecretKeyState: { ...clientSecretKeyState },
  captchaVerifyState: { ...captchaVerifyState },
  trmRedirectUrlState: { ...trmRedirectUrlState },
  validateInvitationState: { ...validateInvitationState },
  timerState: { ...timerState },
  loginOTPState: { ...loginOTPState },
  validateLoginOtpState: { ...validateLoginOtpState },
  resendEmailState: { ...resendEmailState },
  newUserState: { ...newUserState },
  userEnvState: { ...userEnvState },
  productRefreshTokenState: { ...productRefreshTokenState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.TOGGLE_ENVIRONMENT_SUCCESS: {
      const newLoginState = {
        ...state.loginState,
        ...generateUserData(action.payload.body),
        isLoading: false,
        isSuccess: true,
        isFailure: false,
      };
      return {
        ...state,
        loginState: newLoginState,
      };
    }
    case actionConstants.POST_LOGIN_REQUEST:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          loginTimeLeft: 0,
          UserEmail: '',
          showOtpScreen: false,
        },
      };

    case actionConstants.POST_LOGIN_SUCCESS:
      if (action.payload.body.show_otp_page) {
        setIsLiveMerchant(
          `${
            'isLiveMerchant' in action.payload?.body
              ? action.payload?.body?.isLiveMerchant
              : true
          }`
        );
        return {
          ...state,
          loginState: {
            ...state.loginState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            showOtpScreen: true,
            UserEmail: action.payload.extra.userEmail,
            isLiveMerchant:
              'isLiveMerchant' in action.payload?.body
                ? action.payload?.body?.isLiveMerchant
                : true,
            isSelfServe: action.payload?.body?.isSelfServe,
            is_merchant_onboarded_on_live: action.payload?.body?.is_merchant_onboarded_on_live,
            maxPaymentAllowedLimitInPaise: action?.payload?.body?.maxPaymentAllowedLimitInPaise,
            otpToken: action?.payload?.body?.otp_token,
          },
        };
      }
      return {
        ...state,
        loginState: {
          ...state.loginState,
          ...generateUserData(action.payload.body),
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          opCode: action.payload.body.OpCode,
          showPasswordExpiryNotification: true,
          pushClevertapLoginContinueEvent: true,
        },
        permissionState: {
          ...generatePermissionState(action.payload.body),
        },
        roleState: {
          ...generateRoleState(action.payload.body),
        },
      };

    case actionConstants.POST_LOGIN_FAILURE:
      if (
        action.payload.body.is_suspended &&
        action.payload.body.login_time_left > 0
      ) {
        return {
          ...state,
          loginState: {
            ...state.loginState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            isUserAuthenticated: false,
            opCode: action.payload.body.error_code,
            message: action.payload.body.error_message,
            MerchantId: 0,
            isWaitingForAPIResponse: false,
            loginTimeLeft: action.payload.body.login_time_left,
            UserEmail: action.payload.extra.userEmail,
          },
        };
      }
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          isUserAuthenticated: false,
          opCode: action.payload.body.error_code,
          message: action.payload.body.error_message,
          remainingAttempts: action.payload.body.remaining_attempts,
          MerchantId: 0,
          isWaitingForAPIResponse: false,
          UserEmail: action.payload.extra.userEmail,
        },
      };
    case actionConstants.VALIDATE_LOGIN_OTP_REQUEST:
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
          isLoading: true,
        },
      };

    case actionConstants.VALIDATE_LOGIN_OTP_SUCCESS:
      if (action.payload.body?.MerchantList?.length > 1) {
        return {
          ...state,
          validateLoginOtpState: {
            ...validateLoginOtpState,
            isSuccess: true,
            MerchantList: action.payload.body?.MerchantList,
            showOtpScreen: true,
          },
        };
      } 
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
          isSuccess: true,
        },
        loginState: {
          ...state.loginState,
          ...generateUserData(action.payload.body),
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          opCode: action.payload.body.OpCode,
          showPasswordExpiryNotification: true,
          showOtpScreen: false,
        },
        permissionState: {
          ...generatePermissionState(action.payload.body),
        },
        roleState: {
          ...generateRoleState(action.payload.body),
        },
      };
    case actionConstants.VALIDATE_LOGIN_OTP_FAILURE:
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
          isFailure: true,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
          otpExpired: action.payload.body.show_resend_button,
        },
        loginState: {
          ...state.loginState,
          loginTimeLeft: action.payload.body.login_time_left || 0,
          showOtpScreen: action.payload.body.is_suspended
            ? false
            : state.loginState.showOtpScreen,
        },
      };
    case actionConstants.SET_USER_DATA:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          ...action.payload.data,
        },
      };

    case actionConstants.GET_DISPUTES_FEATURE_FLAG_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isDisputesEnabled: action.payload?.body?.enabled ?? false,
        },
      };

    case actionConstants.GET_DISPUTES_FEATURE_FLAG_FAILURE:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isDisputesEnabled: false,
        },
      };

    case actionConstants.POST_LOGIN_CLEAR:
      return {
        ...state,
        loginState: {
          ...loginState,
          isAdmin: state.loginState.isAdmin,
        },
      };

    case actionConstants.CLEAR_AUTH_SESSION:
      return {
        ...state,
        loginState: {
          ...loginState,
          isAdmin: state.loginState.isAdmin,
          isWaitingForAPIResponse: false,
        },
        permissionState,
        roleState,
        logOutState,
      };

    case actionConstants.POST_NEW_SIGN_UP_REQUEST:
      return {
        ...state,
        newSignUpState: {
          ...state.newSignUpState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          isSignupCompleted: false,
        },
      };

    case actionConstants.POST_NEW_SIGN_UP_SUCCESS:
      return {
        ...state,
        newSignUpState: {
          ...state.newSignUpState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          isSignupCompleted: action.payload.body,
        },
      };

    case actionConstants.POST_NEW_SIGN_UP_FAILURE:
      return {
        ...state,
        newSignUpState: {
          ...state.newSignUpState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          isSignupCompleted: false,
          opCode: action.payload.body.error_code,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_NEW_SIGN_UP_CLEAR:
      return {
        ...state,
        newSignUpState,
      };

    case actionConstants.POST_REFRESH_TOKEN_REQUEST:
      if (action.payload?.silentRefresh) {
        return {
          ...state,
          loginState: {
            ...state.loginState,
            isSilentRefreshLoading: true,
            isTokenSuccess: false,
            isTokenFailure: false,
          },
        };
      }

      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: true,
          isTokenSuccess: false,
          isTokenFailure: false,
          isWaitingForAPIResponse: true,
        },
      };

    case actionConstants.POST_REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          ...generateUserData(
            action.payload.body,
            action?.payload?.extra?.pathName
          ),
          ...(action.payload.body.isAdmin && {
            MerchantId: state.loginState.MerchantId,
            merchantName: state.loginState.merchantName,
            merchantPayoutEnabled: state.loginState.merchantPayoutEnabled,
            merchantUDFEnabled: state.loginState.merchantUDFEnabled,
            merchantTPVEnable: state.loginState.merchantTPVEnabled,
            merchantVersion: state.loginState.merchantVersion,
          }),
          isPartnerMerchant: action.payload?.body?.isPartnerMerchant,
          partnerId: action.payload?.body?.MerchantId,
          partnerEdgeMerchantId: state.loginState.partnerEdgeMerchantId,
          isLoading: false,
          isSilentRefreshLoading: false,
          isTokenSuccess: true,
          isTokenFailure: false,
          isTokenRefreshed: true,
          citi: false,
          isMCC: action.payload?.body?.isMCC,
          isPACB: action.payload?.body?.isPACB,
          isParentToChild: action?.payload?.body?.isParentToChild ?? false,
          parentMerchantId: action?.payload?.body?.parentMerchantId ?? null,
          isParentMerchant: action?.payload?.body?.isParentMerchant ?? false,
        },
        permissionState: { ...generatePermissionState(action.payload.body) },
        roleState: {
          ...generateRoleState(action.payload.body),
        },
      };

    case actionConstants.POST_REFRESH_TOKEN_FAILURE: {
      const isSilentAuth = action.payload?.extra?.silentAuth;
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: false,
          isSilentRefreshLoading: false,
          isTokenSuccess: false,
          isTokenFailure: !isSilentAuth,
          isUserAuthenticated: false,
          opCode: action.payload.body?.error_code,
          isTokenRefreshed: false,
          isWaitingForAPIResponse: false,
        },
      };
    }

    case actionConstants.POST_REFRESH_TOKEN_CLEAR:
      return {
        ...state,
        loginState,
      };

    case actionConstants.POST_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePasswordState: {
          ...state.changePasswordState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          isPasswordChanged: false,
        },
      };

    case actionConstants.POST_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordState: {
          ...state.changePasswordState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          opCode: action.payload.body.error_code,
          isPasswordChanged: true,
        },
      };

    case actionConstants.POST_CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changePasswordState: {
          ...state.changePasswordState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          isPasswordChanged: false,
          opCode: action.payload.body.error_code,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_CHANGE_PASSWORD_CLEAR:
      return {
        ...state,
        changePasswordState,
      };

    case actionConstants.POST_LOGOUT_REQUEST:
      return {
        ...state,
        logOutState: {
          ...state.logOutState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          isUserLoggedOut: false,
        },
      };

    case actionConstants.POST_LOGOUT_SUCCESS:
      return {
        ...state,
        logOutState: {
          ...state.logOutState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          isUserLoggedOut: action.payload.body,
        },
      };

    case actionConstants.POST_LOGOUT_FAILURE:
      return {
        ...state,
        logOutState: {
          ...state.logOutState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          opCode: action.payload.body.error_code,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_LOGOUT_CLEAR:
      return {
        ...state,
        logOutState,
      };

    case actionConstants.POST_SAVE_NEW_PASSWORD_REQUEST:
      return {
        ...state,
        saveNewPasswordState: {
          ...state.saveNewPasswordState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          isPasswordChanged: false,
        },
      };

    case actionConstants.POST_SAVE_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        saveNewPasswordState: {
          ...state.saveNewPasswordState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          isPasswordChanged: action.payload.body,
        },
      };

    case actionConstants.POST_SAVE_NEW_PASSWORD_FAILURE:
      return {
        ...state,
        saveNewPasswordState: {
          ...state.saveNewPasswordState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          opCode: action.payload.body.error_code,
          message: action.payload.body.error_message,
        },
      };

    case actionConstants.POST_SAVE_NEW_PASSWORD_CLEAR:
      return {
        ...state,
        saveNewPasswordState,
      };

    case actionConstants.POST_FORGET_PASSWORD_REQUEST:
      return {
        ...state,
        forgetPasswordState: {
          ...state.forgetPasswordState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
          message: '',
        },
      };

    case actionConstants.POST_FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        forgetPasswordState: {
          ...state.forgetPasswordState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          otpToken: action.payload.body.otpToken,
          otpExpiryInSeconds: action.payload.body.otpExpiryInSeconds,
          message: '',
        },
        validateOtpState: {
          ...state.validateOtpState,
          showResendButton: action.payload.body.show_resend_button ?? false,
        },
      };

    case actionConstants.POST_FORGET_PASSWORD_FAILURE:
      return {
        ...state,
        forgetPasswordState: {
          ...state.forgetPasswordState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          opCode: action.payload.body.error_code,
          message: action.payload.body.error_message,
        },
        loginState: {
          ...state.loginState,
          loginTimeLeft:
            action.payload.body.login_time_left ||
            state.loginState.loginTimeLeft,
          UserEmail:
            action.payload.body.login_time_left > 0
              ? action.payload.extra.userEmail
              : state.loginState.UserEmail,
        },
      };

    case actionConstants.POST_FORGET_PASSWORD_CLEAR:
      return {
        ...state,
        forgetPasswordState,
      };

    case actionConstants.POST_VALIDATE_OTP_REQUEST:
      return {
        ...state,
        validateOtpState: {
          ...state.validateOtpState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
          isValid: false,
          showResendButton: false,
        },
      };

    case actionConstants.POST_VALIDATE_OTP_SUCCESS:
      return {
        ...state,
        validateOtpState: {
          ...state.validateOtpState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          isValid: action.payload.body,
          message: '',
        },
      };

    case actionConstants.POST_VALIDATE_OTP_FAILURE:
      return {
        ...state,
        validateOtpState: {
          ...state.validateOtpState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          isValid: false,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
          showResendButton: action.payload.body.show_resend_button,
        },
      };

    case actionConstants.POST_VALIDATE_OTP_CLEAR:
      return {
        ...state,
        validateOtpState,
      };

    case actionConstants.SET_MERCHANT_INFO:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          MerchantId: action?.payload?.data?.merchantId,
          merchantName: action?.payload?.data?.merchantName,
          merchantTRMEnabled: action?.payload?.data?.isTRMEnabled,
          merchantUDFEnabled: action?.payload?.data?.isUDFEnabled,
          merchantEmailId: action?.payload?.data?.merchantEmailId ?? '',
          merchantPayoutEnabled: action?.payload?.data?.isPayoutEnabled ?? '',
          payoutBankId: action?.payload?.data?.payoutBankId ?? '',
          merchantTPVEnabled: action?.payload?.data?.isTPVEnabled,
          merchantSubscriptionEnabled:
          action.payload?.body?.mappedProducts?.filter(
            (product) => product?.id === 4 && product?.status === 2
          )?.length > 0
            ? true
            : false,
          isPartnerMerchant: action?.payload?.data?.isPartnerMerchant,
        },
      };
    case actionConstants.CLEAR_MERCHANT_INFO:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          MerchantId: 0,
          merchantName: '',
          merchantEmailId: '',
          merchantPayoutEnabled: false,
          payoutBankId: '',
          selectedMerchant: null,
          subMerchants:[],
          citi:false
        },
      };

    // Update Merchant TRM Status
    case actionConstants.PUT_UPDATE_MERCHANT_TRM_STATUS_REQUEST:
      return {
        ...state,
        updateTRMStatusState: {
          ...state.updateTRMStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          opCode: 0,
        },
        loginState: {
          ...state.loginState,
          merchantTRMEnabled: action.payload?.status,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TRM_STATUS_SUCCESS:
      return {
        ...state,
        updateTRMStatusState: {
          ...state.updateTRMStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          opCode: action.payload?.body?.response_code ?? 0,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TRM_STATUS_FAILURE:
      return {
        ...state,
        updateTRMStatusState: {
          ...state.updateTRMStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          opCode: action.payload?.body?.response_code ?? 0,
        },
        loginState: {
          ...state.loginState,
          merchantTRMEnabled: !action.payload?.extra?.status,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_TRM_STATUS_CLEAR:
      return {
        ...state,
        updateTRMStatusState,
      };
    case actionConstants.CLIENT_SECRET_KEY_REQUEST:
      return {
        ...state,
        clientSecretKeyState: {
          ...state.clientSecretKeyState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    case actionConstants.CLIENT_SECRET_KEY_SUCCESS:
      return {
        ...state,
        clientSecretKeyState: {
          ...state.clientSecretKeyState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.secret,
          message: action.payload.body.response_message,
        },
      };
    case actionConstants.CLIENT_SECRET_KEY_FAILURE:
      return {
        ...state,
        clientSecretKeyState: {
          ...state.clientSecretKeyState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: '',
          message: action.payload.body.response_message,
        },
      };
    case actionConstants.CAPTCHA_VERIFY_REQUEST:
      return {
        ...state,
        captchaVerifyState: {
          ...state.captchaVerifyState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          message: '',
        },
      };
    case actionConstants.CAPTCHA_VERIFY_SUCCESS:
      return {
        ...state,
        captchaVerifyState: {
          ...state.captchaVerifyState,
          isLoading: false,
          isSuccess: action.payload.body.success,
          isFailure: !action.payload.body.success,
          data: action.payload.body.secret,
          message: action.payload.body.response_message,
        },
      };
    case actionConstants.CAPTCHA_VERIFY_FAILURE:
      return {
        ...state,
        captchaVerifyState: {
          ...state.captchaVerifyState,
          isLoading: false,
          isSuccess: action.payload.body.success,
          isFailure: true,
          data: '',
          message: action.payload.body.response_message,
        },
      };
    case actionConstants.CAPTCHA_VERIFY_CLEAR:
      return {
        ...state,
        captchaVerifyState,
      };
    case actionConstants.SET_EXPIRY_TOKEN_NOTIFICATION:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          showPasswordExpiryNotification: action.payload?.show,
        },
      };

    case actionConstants.GET_TRM_REDIRECT_URL_SUCCESS:
      return {
        ...state,
        trmRedirectUrlState: {
          ...trmRedirectUrlState,
          isSuccess: true,
          trmRedirectUrl: action.payload.body.redirectUrl,
          responseCode: action.payload.body.response_code,
          responseMessage: action.payload.body.response_message,
        },
      };
    case actionConstants.GET_TRM_REDIRECT_URL_FAILURE:
      return {
        ...state,
        trmRedirectUrlState: {
          ...trmRedirectUrlState,
          isFailure: true,
          responseCode: action.payload.body.error_code,
          responseMessage: action.payload.body.error_message,
        },
      };
    case actionConstants.GET_TRM_REDIRECT_URL_CLEAR:
      return {
        ...state,
        trmRedirectUrlState: {
          ...trmRedirectUrlState,
        },
      };
    case actionConstants.GET_VALIDATE_INVITATION_URL_REQUEST:
      return {
        ...state,
        validateInvitationState: {
          ...state.validateInvitationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: '',
          errorMessage: '',
        },
      };

    case actionConstants.GET_VALIDATE_INVITATION_URL_SUCCESS:
      return {
        ...state,
        validateInvitationState: {
          ...state.validateInvitationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload.body.response_code,
          responseMessage: action.payload.body.response_message,
        },
      };

    case actionConstants.GET_VALIDATE_INVITATION_URL_FAILURE:
      return {
        ...state,
        validateInvitationState: {
          ...state.validateInvitationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
        },
      };

    case actionConstants.GET_VALIDATE_INVITATION_URL_CLEAR:
      return {
        ...state,
        validateInvitationState,
      };

    case actionConstants.GET_LOGIN_OTP_REQUEST:
      return {
        ...state,
        loginOTPState: {
          ...state.loginOTPState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: '',
          errorMessage: '',
          responseCode: '',
          responseMessage: '',
          otpToken: '',
          type: LOGIN_CONSTANTS.FETCH_LOGIN_OTP_API_TYPE_FETCH,
        },
      };

    case actionConstants.GET_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        loginOTPState: {
          ...state.loginOTPState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          otpToken: action.payload.body.otp_token,
          responseCode: action.payload.body.response_code,
          responseMessage: action.payload.body.response_message,
          type: LOGIN_CONSTANTS.FETCH_LOGIN_OTP_API_TYPE_FETCH,
        },
      };

    case actionConstants.GET_LOGIN_OTP_FAILURE:
      return {
        ...state,
        loginOTPState: {
          ...state.loginOTPState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
          type: LOGIN_CONSTANTS.FETCH_LOGIN_OTP_API_TYPE_FETCH,
        },
        loginState: {
          ...state.loginState,
          loginTimeLeft: action.payload.body.login_time_left || 0,
          showOtpScreen: action.payload.body.is_suspended
            ? false
            : state.loginState.showOtpScreen,
        },
      };

    case actionConstants.GET_LOGIN_OTP_CLEAR:
      return {
        ...state,
        loginOTPState,
      };

    case actionConstants.RESEND_LOGIN_OTP_REQUEST:
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
        },
        loginOTPState: {
          ...state.loginOTPState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: '',
          errorMessage: '',
          responseCode: '',
          responseMessage: '',
          otpToken: '',
          type: LOGIN_CONSTANTS.FETCH_LOGIN_OTP_API_TYPE_RESEND,
        },
      };

    case actionConstants.RESEND_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        loginOTPState: {
          ...state.loginOTPState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          otpToken: action.payload.body.otp_token,
          responseCode: action.payload.body.response_code,
          responseMessage: action.payload.body.response_message,
          type: LOGIN_CONSTANTS.FETCH_LOGIN_OTP_API_TYPE_RESEND,
        },
        loginState: {
          ...state.loginState,
          otpToken: action.payload.body.otp_token,
        },
      };

    case actionConstants.RESEND_LOGIN_OTP_FAILURE:
      return {
        ...state,
        loginOTPState: {
          ...state.loginOTPState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
          loginTimeLeft: action.payload.body.login_time_left,
          type: LOGIN_CONSTANTS.FETCH_LOGIN_OTP_API_TYPE_RESEND,
        },
        loginState: {
          ...state.loginState,
          loginTimeLeft: action.payload.body.login_time_left || 0,
          showOtpScreen: action.payload.body.is_suspended
            ? false
            : state.loginState.showOtpScreen,
        },
      };

    case actionConstants.RESEND_LOGIN_OTP_CLEAR:
      return {
        ...state,
        loginOTPState,
      };

    case actionConstants.SET_IS_TIMER_COMPTLETE:
      return {
        ...state,
        timerState: {
          isTimerComplete: action.payload.isTimerComplete,
        },
      };

    case actionConstants.PUT_UPDATE_MERCHANT_SUBSCRIPTION_SUCCESS: 
    return {
      ...state,
        loginState: {
          ...state.loginState,
          mappedProducts: action.payload?.body?.productList ?? [
            ...state.loginState.mappedProducts,
          ],
          merchantSubscriptionEnabled:
            action.payload?.body?.productList?.filter(
              (product) => product?.id === 4
            )?.length > 0
              ? true
              : false,
        },
    };

    case actionConstants.PUT_UPDATE_PAYOUT_MODULE_STATUS_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          mappedProducts: action.payload?.body?.productList ?? [
            ...state.loginState.mappedProducts,
          ],
          merchantPayoutEnabled:
            action.payload?.body?.productList?.filter(
              (product) => product?.id === 3
            )?.length > 0
              ? true
              : false,
        },
      };

    case actionConstants.CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          merchantUDFEnabled:
            action.payload?.extra?.isSubscribeRequest ?? false,
        },
      };
    case actionConstants.PUT_UPDATE_MERCHANT_TPV_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          merchantTPVEnabled: action.payload?.extra?.enable_tpv ?? false,
        },
      };

    // case actionConstants.PUT_UPDATE_MERCHANT_SUBSCRIPTION_SUCCESS:
    //   return {
    //     ...state,
    //     loginState: {
    //       ...state.loginState,
    //       merchantSubscriptionEnabled:
    //         action.payload?.extra?.enable_subscription ?? false,
    //     },
    //   };

    case actionConstants.FETCH_MERCHANT_REQUEST:
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
          isLoading: true,
        },
      };

    case actionConstants.FETCH_MERCHANT_SUCCESS: {
      const isFromDropdown = Boolean(action.payload?.extra?.subMerchants);
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
          isSuccess: true,
        },
        loginState: {
          ...state.loginState,
          ...generateUserData(action.payload.body),
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          opCode: action.payload.body.OpCode,
          showPasswordExpiryNotification: true,
          showOtpScreen: false,
          ...(isFromDropdown && {
            subMerchants: action.payload.extra.subMerchants,
            selectedMerchant: action.payload.extra.selectedMerchant,
            partnerEdgeMerchantId: action.payload.extra.partnerEdgeMerchantId,
            partnerId: action.payload.extra.partnerId,
            isPartnerMerchant: action.payload.extra.isPartnerMerchant,
          }),
        },
        permissionState: {
          ...generatePermissionState(action.payload.body),
        },
        roleState: {
          ...generateRoleState(action.payload.body),
        },
      };
    }
    
    case actionConstants.FETCH_MERCHANT_UPDATE_TOGGLE:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLiveMerchant: action.payload.body,
        },
      };
    case actionConstants.FETCH_MERCHANT_FAILURE:
      return {
        ...state,
        validateLoginOtpState: {
          ...validateLoginOtpState,
          isFailure: true,
          errorCode: action.payload.body.error_code,
          errorMessage: action.payload.body.error_message,
          otpExpired: action.payload.body.show_resend_button,
        },
        loginState: {
          ...state.loginState,
          loginTimeLeft: action.payload.body.login_time_left || 0,
          showOtpScreen: action.payload.body.is_suspended
            ? false
            : state.loginState.showOtpScreen,
        },
      };
    case actionConstants.RESEND_EMAIL_REQUEST:
      return {
        ...state,
        resendEmailState: {
          ...state.resendEmailState,
          isSuccess: false,
          isLoading: true,
          isFailure: false,
        },
      };
    case actionConstants.RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        resendEmailState: {
          ...state.resendEmailState,
          isSuccess: true,
          isLoading: false,
          isFailure: false,
        },
      };
    case actionConstants.RESEND_EMAIL_FAILURE:
      return {
        ...state,
        resendEmailState: {
          ...state.resendEmailState,
          isSuccess: false,
          isLoading: false,
          isFailure: true,
        },
      };
    case actionConstants.NEWUSER_REQUEST:
      return {
        ...state,
        newUserState: {
          ...state.newUserState,
          isSuccess: false,
          isLoading: true,
          isFailure: false,
          data: {},
          error: {},
        },
      };
    case actionConstants.NEWUSER_SUCCESS:
      return {
        ...state,
        newUserState: {
          ...state.newUserState,
          isSuccess: true,
          isLoading: false,
          isFailure: false,
          data: action.payload.body,
          error: {},
        },
      };
    case actionConstants.NEWUSER_FAILURE:
      return {
        ...state,
        newUserState: {
          ...state.newUserState,
          isSuccess: false,
          isLoading: false,
          isFailure: true,
          data: {},
          error: action.payload.body,
        },
      };
    case actionConstants.USER_ENV_REQUEST:
      return {
        ...state,
        userEnvState: {
          ...state.userEnvState,
          isSuccess: false,
          isLoading: true,
          isFailure: false,
          data: {},
          error: {},
        },
      };
    case actionConstants.USER_ENV_SUCCESS:
      return {
        ...state,
        userEnvState: {
          ...state.userEnvState,
          isSuccess: true,
          isLoading: false,
          isFailure: false,
          data: action.payload.body,
          UserEmail: action.payload.extra.userEmail,
          error: {},
        },
      };
    case actionConstants.USER_ENV_FAILURE:
      return {
        ...state,
        userEnvState: {
          ...state.userEnvState,
          isSuccess: false,
          isLoading: false,
          isFailure: true,
          data: {},
          error: action.payload.body,
          UserEmail: action.payload.extra.userEmail,
        },
      };
    case actionConstants.USER_ENV_CLEAR:
      return {
        ...state,
        userEnvState,
      };

    case actionConstants.GET_MERCHANT_DETAILS_FOR_DASHBOARD_REQUEST:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: true,
        },
      };

    case actionConstants.GET_MERCHANT_DETAILS_FOR_DASHBOARD_SUCCESS:{
     let merchantVersion = action?.payload?.body?.merchantVersion ?? '';
     let checkoutVersion: string | null = null;
     if (merchantVersion === "v31" || merchantVersion === "V31") {
      merchantVersion = "V3";
      checkoutVersion = "V31";
  }
     let parsedDashboardData: any = {};
     try {
       parsedDashboardData = action?.payload?.body?.data
         ? JSON.parse(action.payload.body.data)
         : {};
     } catch (e) {
       parsedDashboardData = {};
     }
      return {
        ...state,
        loginState: {
          ...state.loginState,
          unifiedId: action?.payload?.body?.merchantId,
          mappedProducts: action?.payload?.body?.mappedProducts,
          selectedProduct: action?.payload?.body?.mappedProducts[0],
          merchantUDFEnabled: action?.payload?.body?.isUDFEnabled,
          merchantTPVEnabled: action?.payload?.body?.isTPVEnabled,
          merchantSubscriptionEnabled:
            action.payload?.body?.mappedProducts?.filter(
              (product) => product?.id === 4 && product?.status === 2
            )?.length > 0
              ? true
              : false,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          MerchantId: action?.payload?.extra?.merchantId,
          merchantName: action?.payload?.extra?.merchantName,
          merchantEmailId: action?.payload?.extra?.merchantEmailId ?? '',
          merchantPayoutEnabled:
            action?.payload?.body?.mappedProducts?.filter(
              (product) => product?.id === 3
            )?.length > 0
              ? true
              : false,
          payoutBankId: action?.payload?.extra?.payoutBankId ?? '',
          merchantTRMEnabled: action?.payload?.extra?.isTRMEnabled,
          token: action?.payload?.body?.token,
          edgeMerchantPaymentLinkEnabled:
            action?.payload?.body?.isEdgePaymentLinkEnabled,
          merchantVersion,
          checkoutVersion, 
          isPartnerMerchant: action?.payload?.body?.isPartnerMerchant,
          partnerId: action?.payload?.extra?.merchantId,
          partnerEdgeMerchantId: action.payload?.body?.partnerEdgeMerchantId,
          isAdapter: action.payload?.body?.isAdapter,
          isDCC: action.payload?.body?.isDCC,
          isMCC: action.payload?.body?.isMCC,
          isPACB: action.payload?.body?.isPACB,
          maxPaymentAllowedLimitInPaise:
            action.payload?.body?.maxPaymentAllowedLimitInPaise,
          isMerchantOnboardedOnLive: action?.payload?.body?.is_merchant_onboarded_on_live,
          isAggregator: action?.payload?.body?.isAggregator,
          isRefundViaPayout: action?.payload?.body?.isRefundViaPayout,  
          isParentMerchant: action?.payload?.body?.isParentMerchant ?? false,
          isTransactingMerchant: action?.payload?.body?.isTransactingMerchant ?? true,
          isPaCbEnabled: action?.payload?.body?.isPaCbEnabled ?? false,
          isFirstLogin: action?.payload?.body?.isFirstLogin ?? false,
          commodityType: action?.payload?.body?.commodityType ?? '',
          allowedSettlementCurrencies:
            action?.payload?.body?.allowedSettlementCurrencies ??
            action?.payload?.body?.AllowedSettlementCurrencies ??
            parsedDashboardData?.allowedSettlementCurrencies ??
            parsedDashboardData?.AllowedSettlementCurrencies ??
            [],
        },
      };
      }
    case actionConstants.UPDATE_MAX_PAYMENT_LINK_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          maxPaymentAllowedLimitInPaise: action.payload.body?.updatedAmountInPaise
        },
      };

    case actionConstants.GET_MERCHANT_DETAILS_FOR_DASHBOARD_FAILURE:

      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

  case actionConstants.GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_REQUEST:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: true,
        },
      };

    case actionConstants.GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          mappedProducts: action?.payload?.body?.mappedProducts,
          selectedProduct: action?.payload?.body?.mappedProducts[0],
          merchantUDFEnabled: action?.payload?.body?.isUDFEnabled,
          merchantTPVEnabled: action?.payload?.body?.isTPVEnabled,
          merchantSubscriptionEnabled:
          action.payload?.body?.mappedProducts?.filter(
            (product) => product?.id === 4 && product?.status === 2
          )?.length > 0
            ? true
            : false,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          MerchantId: action?.payload?.extra?.partnerId ? action?.payload?.extra?.partnerId : action?.payload?.extra?.merchantId,
          merchantName: action?.payload?.extra?.merchantName,
          merchantEmailId: action?.payload?.extra?.merchantEmailId ?? '',
          merchantPayoutEnabled:
            action?.payload?.body?.mappedProducts?.filter(
              (product) => product?.id === 3
            )?.length > 0
              ? true
              : false,
          payoutBankId: action?.payload?.extra?.payoutBankId ?? '',
          merchantTRMEnabled: action?.payload?.extra?.isTRMEnabled,
          token: action?.payload?.body?.token,
          edgeMerchantPaymentLinkEnabled:
            action?.payload?.body?.isEdgePaymentLinkEnabled,
          merchantVersion : action?.payload?.body?.merchantVersion ?? '',
          subMerchants: action?.payload?.body?.subMerchants ?? [],
          selectedMerchant: "",
          citi: action?.payload?.extra?.citi ?? false,
          isParentMerchant: action?.payload?.body?.isParentMerchant ?? false,
          isParentToChild: action?.payload?.body?.isParentToChild ?? false,
          parentMerchantId: action?.payload?.body?.parentMerchantId ?? null,
          isTransactingMerchant: action?.payload?.body?.isTransactingMerchant ?? true,
          isPaCbEnabled: action?.payload?.body?.isPaCbEnabled ?? false,
          isFirstLogin: action?.payload?.body?.isFirstLogin ?? false,
          commodityType: action?.payload?.body?.commodityType ?? '',
          allowedSettlementCurrencies: action?.payload?.body?.allowedSettlementCurrencies ?? [],
        },
      };

    case actionConstants.GET_PARTNER_MERCHANT_DETAILS_FOR_DASHBOARD_FAILURE:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          citi:false
        },
      };

    case actionConstants.UPDATE_SELECTED_PRODUCT_ON_PATH_CHANGE:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          selectedProduct: action?.payload?.selectedProduct,
        },
      };

    case actionConstants.POST_UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          ...(action?.payload?.extra?.isShowGuidedTourUpdated
            ? { showGuidedTour: false }
            : {}),
        },
      };

    case actionConstants.POST_UPDATE_USER_DETAILS_FAILURE:
      return {
        ...state,
        loginState: {
          ...state.loginState,
          ...(action?.payload?.extra?.isShowGuidedTourUpdated
            ? { showGuidedTour: false }
            : {}),
        },
      };

    default:
      return state;
  }
}
